// 组件类
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { debounce } from "lodash";
import { getTranslation } from "../../utils/utils";

@Component({
  selector: "rs-search-input",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class SearchInputComponent implements OnInit {
  constructor() {}
  @Input()
  placeholder = "";
  @Output()
  hanleSearch = new EventEmitter();
  @Output()
  handleInput = new EventEmitter();
  private debouncedInput: Function;
  searchValue = "";
  translation;

  ngOnInit() {
    this.getInfo();
    this.debouncedInput = debounce(() => {
      this.onSeach();
    }, 300);
  }

  getInfo() {
    this.translation = getTranslation();
    this.placeholder = this.placeholder || this.translation.SEARCH;
  }
  onInput(e) {
    this.handleInput.emit(e.value);
    this.debouncedInput();
  }

  onSeach() {
    this.hanleSearch.emit(this.searchValue);
  }
}
